/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Row } from "antd";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { theme, MixStyle } from "../../styles";
import { Menu, Dropdown } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { updateCurrentPath } from "../../redux/Action/pageRoot";
import {
  Grid,
  Section,
  Typography,
  Button,
  FilterWraper,
  Tabel,
  Loading,
} from "../../core";
import { getAllBuyers, deleteBuyer } from "../../helper/utils/api/buyer";
import EditBuyerModal from "../../components/Modals/Buyer/EditBuyerModal";
import DeleteModals from "../../components/Modals/deleteModals";

const { colors } = theme;

const btnProps = {
  height: "30px",
  bg: "#FF5687",
  width: "130px",
  shadow: "0px 2px 20px rgba(0, 0, 0, 0.15)",
  margin: "0px",
};

const typoProps = {
  as: "h3",
  color: colors.Fiord,
  weight: "bold",
  letterSpacing: "0.2px",
};

const StyledButton = styled(Button)`
  ${MixStyle.Link}
  ${MixStyle.flexCenter}
  color:white;
`;

const BuyerList = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const [modalState, setModalState] = useState({
    editBuyerModal: false,
    deleteConfirmModal: false,
  });

  const [record, setRecord] = useState({
    recordToDelete: {},
    recordToEdit: {},
  });

  const [buyers, setBuyers] = useState([]);
  const history = useHistory();

  useEffect(() => {
    dispatch(updateCurrentPath("Buyer", "Buyer list"));
    getAllBuyersWithCompanyId();
  }, []);

  const getAllBuyersWithCompanyId = async () => {
    let companyId = localStorage.getItem("companyId");
    if (companyId) {
      setIsLoading(true);
      try {
        let {
          data: { result },
        } = await getAllBuyers({ companyId });
        setBuyers(result);
      } catch (error) {
        console.log("error get buyers =>", error);
      }
      setIsLoading(false);
    }
  };

  const deleteBuyerHandler = (record) => {
    setModalState((prev) => ({
      ...prev,
      deleteConfirmModal: true,
    }));
    setRecord({
      recordToDelete: record,
      recordToEdit: {},
    });
  };

  const editBuyer = (record) => {
    setModalState((prev) => ({
      ...prev,
      editBuyerModal: true,
    }));
    setRecord({
      recordToDelete: {},
      recordToEdit: record,
    });
  };

  const closeModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  const confirmDeleteHandler = async () => {
    debugger;
    if (record.recordToDelete) {
      let { _id } = record.recordToDelete;
      if (_id) {
        setIsLoading(true);
        try {
          await deleteBuyer(_id);
          closeModal("deleteConfirmModal");
          await getAllBuyersWithCompanyId();
        } catch (error) {
          console.log("error delete", error);
        }
        setIsLoading(false);
      }
    }
  };

  const menu = (index, record) => {
    return (
      <Menu>
        <Menu.Item onClick={() => deleteBuyerHandler(record)}>Delete</Menu.Item>
        <Menu.Item
          onClick={() => {
            editBuyer(record);
          }}
        >
          Edit
        </Menu.Item>
      </Menu>
    );
  };

  const columns = [
    {
      title: "Buyer Name",
      dataIndex: "buyerName",
      key: "buyerName",
      width: 150,

      render: (text, record, index) => (
        <div className="profile--img--box">
          {/* <div>
            <Avatar size={44} src={record.imgUrl} />
          </div> */}
          <div className="m-auto">{record.buyerName}</div>
        </div>
      ),
    },
    {
      title: "Company",
      dataIndex: "companyName",
      key: "companyName",
      width: 150,
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      width: 150,
    },
    {
      title: "NTN",
      dataIndex: "NTN",
      key: "NTN",
      width: 150,
    },
    {
      title: "STRN",
      dataIndex: "STRN",
      key: "STRN",
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 150,
      onCell: (record, rowIndex) => ({
        onClick: (e) => e.stopPropagation(),
      }),
      render: (text, record, index) => (
        <Dropdown
          overlay={() => menu(index, record)}
          onClick={(e) => e.stopPropagation()}
          trigger="click"
        >
          <MoreOutlined />
        </Dropdown>
      ),
    },
  ];

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      <Section className="mt-20" padding="20px">
        <Row type="flex" justify="space-between" align="middle">
          <Typography {...typoProps} noMargin text=" Buyer Details" />
          <StyledButton {...btnProps} onClick={() => history.push("/addBuyer")}>
            Add Buyer
          </StyledButton>
        </Row>
      </Section>
      <Section className="mt-20" padding="20px" radius="10px 10px 0px 0px">
        <FilterWraper
          range={false}
          inpputChange={() => {
            console.log("");
          }}
          dropDown={false}
        >
          <Tabel
            columns={columns}
            data={buyers}
            onRow={(record) => ({
              onClick: () => {
                history.push({
                  pathname: `/buyer-inner/${record.companyName}`,
                  state: record,
                });
              },
            })}
          />
        </FilterWraper>
      </Section>

      {modalState.editBuyerModal && (
        <EditBuyerModal
          editBuyerModal={modalState.editBuyerModal}
          closeModal={closeModal}
          getAllBuyersWithCompanyId={getAllBuyersWithCompanyId}
          dataToEdit={record.recordToEdit}
        />
      )}
      {modalState.deleteConfirmModal && (
        <DeleteModals
          deleteModalsOpen={modalState.deleteConfirmModal}
          closeModal={closeModal}
          confirmDeleteHandler={confirmDeleteHandler}
        />
      )}
    </Grid>
  );
};
export default BuyerList;
